import { AxiosError, AxiosResponse } from "axios";

import { RESOURCE_CATALOGUE_ENDPOINTS } from "@/features/cost/resourceCatalogue/api/endpoints";
import { AddResourceModel } from "@/features/cost/resourceCatalogue/types/addResourceModel";
import apiRequests from "@/shared/config/axiosConfig";

type ApiResponse = {
  message: string;
  statusCode: number;
};
export default async function addResource(resource: AddResourceModel) {
  const resourceWithType = { ...resource, type: 1 };

  try {
    const url = RESOURCE_CATALOGUE_ENDPOINTS.ADD_RESOURCE;

    const response: AxiosResponse<ApiResponse> = await apiRequests.post(
      url,
      resourceWithType
    );

    const { data, status } = response;

    if (status >= 200 && status < 300) {
      return data;
    }

    throw new Error(`Unknown error occurred with status code ${response.status}`);
  } catch (e) {
    // @todo Handle Error Below
    const error = e as AxiosError;
    switch (error.response?.status) {
      case 400:
        throw new Error("400: Bad Request");
      case 401:
        throw new Error("401: Unauthorized");
      case 404:
        throw new Error("404: Not Found");
      default:
        throw new Error(
          `Unknown error occurred with status code ${error.response?.status}`
        );
    }
  }
}
